/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ContentName} from '../models/ContentName';
import type {Error} from '../models/Error';

export interface DownloadSectionContent$Request {
    conferenceId: number;
    sectionId: number;
}

export interface DownloadSectionContent$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const downloadSectionContentRequest = createAction<PayloadData<void, DownloadSectionContent$Request>>('SECTIONS_CONTENT__DOWNLOAD_SECTION_CONTENT__REQUEST');
export const downloadSectionContentSuccess = createAction<PayloadData<any, DownloadSectionContent$Request>>('SECTIONS_CONTENT__DOWNLOAD_SECTION_CONTENT__SUCCESS');
export const downloadSectionContentFailure = createAction<PayloadData<Error, DownloadSectionContent$Request, true>>('SECTIONS_CONTENT__DOWNLOAD_SECTION_CONTENT__FAILURE');

export const downloadSectionContentActions = [
    downloadSectionContentRequest,
    downloadSectionContentSuccess,
    downloadSectionContentFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {number} meta.sectionId The section id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const downloadSectionContent = (meta: DownloadSectionContent$Request, config?: DownloadSectionContent$Config) => {
    return {
        DOWNLOAD_FILE: {
            types: downloadSectionContentActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/${meta.conferenceId}/sections/${meta.sectionId}/contents`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/octet-stream, application/json',
            }
        },
        ...meta
    }
};

export interface GetSectionContent$Request {
    sectionId: number;
}

export interface GetSectionContent$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSectionContentRequest = createAction<PayloadData<void, GetSectionContent$Request>>('SECTIONS_CONTENT__GET_SECTION_CONTENT__REQUEST');
export const getSectionContentSuccess = createAction<PayloadData<ContentName, GetSectionContent$Request>>('SECTIONS_CONTENT__GET_SECTION_CONTENT__SUCCESS');
export const getSectionContentFailure = createAction<PayloadData<Error, GetSectionContent$Request, true>>('SECTIONS_CONTENT__GET_SECTION_CONTENT__FAILURE');

export const getSectionContentActions = [
    getSectionContentRequest,
    getSectionContentSuccess,
    getSectionContentFailure
] as const;

/**
 * @param {number} meta.sectionId The section id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSectionContent = (meta: GetSectionContent$Request, config?: GetSectionContent$Config) => {
    return {
        CALL_API: {
            types: getSectionContentActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/sections/${meta.sectionId}/contents`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemovedSectionContent$Request {
    sectionId: number;
}

export interface RemovedSectionContent$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removedSectionContentRequest = createAction<PayloadData<void, RemovedSectionContent$Request>>('SECTIONS_CONTENT__REMOVED_SECTION_CONTENT__REQUEST');
export const removedSectionContentSuccess = createAction<PayloadData<void, RemovedSectionContent$Request>>('SECTIONS_CONTENT__REMOVED_SECTION_CONTENT__SUCCESS');
export const removedSectionContentFailure = createAction<PayloadData<Error, RemovedSectionContent$Request, true>>('SECTIONS_CONTENT__REMOVED_SECTION_CONTENT__FAILURE');

export const removedSectionContentActions = [
    removedSectionContentRequest,
    removedSectionContentSuccess,
    removedSectionContentFailure
] as const;

/**
 * @param {number} meta.sectionId The section id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removedSectionContent = (meta: RemovedSectionContent$Request, config?: RemovedSectionContent$Config) => {
    return {
        CALL_API: {
            types: removedSectionContentActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/conferences/sections/${meta.sectionId}/contents`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UploadSectionContent$Request {
    sectionId: number;
    multipartFile?: File | File[];
}

export interface UploadSectionContent$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
    onProgress?: (progress: ProgressEvent) => void;
}

export const uploadSectionContentRequest = createAction<PayloadData<void, UploadSectionContent$Request>>('SECTIONS_CONTENT__UPLOAD_SECTION_CONTENT__REQUEST');
export const uploadSectionContentSuccess = createAction<PayloadData<void, UploadSectionContent$Request>>('SECTIONS_CONTENT__UPLOAD_SECTION_CONTENT__SUCCESS');
export const uploadSectionContentFailure = createAction<PayloadData<Error, UploadSectionContent$Request, true>>('SECTIONS_CONTENT__UPLOAD_SECTION_CONTENT__FAILURE');

export const uploadSectionContentActions = [
    uploadSectionContentRequest,
    uploadSectionContentSuccess,
    uploadSectionContentFailure
] as const;

/**
 * @param {number} meta.sectionId The section id
 * @param {any} [meta.multipartFile]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 * @param {function(ProgressEvent): void} [config.onProgress]
 */
export const uploadSectionContent = (meta: UploadSectionContent$Request, config?: UploadSectionContent$Config) => {
    const TRANSPORT_REQUEST_FILE = {
        multipartFile: meta.multipartFile,
    };
    return {
        UPLOAD_FILE: {
            types: uploadSectionContentActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/conferences/sections/${meta.sectionId}/contents`,
            TRANSPORT_REQUEST_FILE,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            onProgress: config?.onProgress,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

